/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AssistantMCPServerRef = {
  /**
   * The slug of the server's Speakeasy-hosted MCP endpoint (/mcp/{endpoint_slug}). Populated on reads; ignored on writes. Absent when the server has no Speakeasy-hosted endpoint.
   */
  endpointSlug?: string | undefined;
  /**
   * Optional environment slug used when connecting to the MCP server.
   */
  environmentSlug?: string | undefined;
  /**
   * The MCP server slug exposed to the assistant. Covers every backend, including hosted (toolset-backed) servers.
   */
  mcpServerSlug: string;
};

/** @internal */
export const AssistantMCPServerRef$inboundSchema: z.ZodMiniType<
  AssistantMCPServerRef,
  unknown
> = z.pipe(
  z.object({
    endpoint_slug: z.optional(z.string()),
    environment_slug: z.optional(z.string()),
    mcp_server_slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "endpoint_slug": "endpointSlug",
      "environment_slug": "environmentSlug",
      "mcp_server_slug": "mcpServerSlug",
    });
  }),
);
/** @internal */
export type AssistantMCPServerRef$Outbound = {
  endpoint_slug?: string | undefined;
  environment_slug?: string | undefined;
  mcp_server_slug: string;
};

/** @internal */
export const AssistantMCPServerRef$outboundSchema: z.ZodMiniType<
  AssistantMCPServerRef$Outbound,
  AssistantMCPServerRef
> = z.pipe(
  z.object({
    endpointSlug: z.optional(z.string()),
    environmentSlug: z.optional(z.string()),
    mcpServerSlug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      endpointSlug: "endpoint_slug",
      environmentSlug: "environment_slug",
      mcpServerSlug: "mcp_server_slug",
    });
  }),
);

export function assistantMCPServerRefToJSON(
  assistantMCPServerRef: AssistantMCPServerRef,
): string {
  return JSON.stringify(
    AssistantMCPServerRef$outboundSchema.parse(assistantMCPServerRef),
  );
}
export function assistantMCPServerRefFromJSON(
  jsonString: string,
): SafeParseResult<AssistantMCPServerRef, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AssistantMCPServerRef$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AssistantMCPServerRef' from JSON`,
  );
}
